// A faint full-width line whose ends fade out.
export function FadedLine() {
  return (
    <div
      aria-hidden="true"
      className="h-px w-full bg-char/10 [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]"
    />
  );
}
